import { Outlet } from "@tanstack/react-router";
import { appTheme } from "./theme";
import { useAuth } from "@/hooks/useAuth";
import { ConfirmDialogHost } from "@/components/ui/ConfirmDialogHost";

function App() {
    useAuth();

    return (
        <div className={appTheme.classes.root}>
            <a className="skip-link" href="#main-content">Skip to content</a>
            <div id="main-content">
                <Outlet />
            </div>
            <ConfirmDialogHost />
        </div>
    );
}

export default App;
